import React from 'react';
import { SortColumn, TableColumn } from 'components/Table/Table.types';
import TableBody from 'components/Table/TableBody';
import TableHeader from 'components/Table/TableHeader';
import useWindowDimensions from 'hooks/useWindowDimensions';
import { uniqueId } from 'lodash';

import { Table as TableMUI } from '@mui/material';

interface TableProps {
  columns: TableColumn[];
  sortColumn: SortColumn;
  data: unknown[];
  onSort: (sortColumn: SortColumn) => void;
}

const Table: React.FunctionComponent<TableProps> = ({
  columns,
  sortColumn,
  data,
  onSort,
}: TableProps) => {
  const { width } = useWindowDimensions();

  return (
    <TableMUI
      sx={{ minWidth: { xs: width * 0.9, md: 650 } }}
      aria-label='simple table'
    >
      <colgroup>
        {columns.map((c) => (
          <col key={uniqueId()} style={{ width: c?.width }} />
        ))}
      </colgroup>
      <TableHeader columns={columns} sortColumn={sortColumn} onSort={onSort} />
      <TableBody columns={columns} data={data} />
    </TableMUI>
  );
};

export default Table;
